module.exports = __webpack_public_path__ + "img/broadcast-right.043b1f94.png";